import { bscTestnet } from '@reown/appkit/networks'

export const environment = {
    APPKIT_PROJECT_ID: '8d4246b4864adf3c8d6fabc0171b3ab0',
    SUPPORTED_NETWORKS: [bscTestnet],
    DEFAULT_NETWORK: bscTestnet,
    RPC_URL: 'https://bnb-testnet.g.alchemy.com/v2/7bN-L9LKOykBAlIcAaw8U',
    RPC_URLS: {
        [bscTestnet.id]: 'https://bnb-testnet.g.alchemy.com/v2/7bN-L9LKOykBAlIcAaw8U'

    },
    APP_URL: 'http://54.236.53.42/AOC-multisig-admin-dev/',
    API_BASE_URL: 'https://aoclandingbackend.seaswap.co/api/',
    SOCKET_BASE_URL: 'https://aoclandingbackend.seaswap.co/',
    ENCRYPT_LOCAL_STORAGE: false,
    LOCAL_STORAGE_SECRET: 'A86Q2M84E3400875663E8366912AY76365488H'

};
